<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <specimen-source-form
      :isLoading="isLoading"
      :onSubmit="onSubmit">
    </specimen-source-form>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import SpecimenSourceForm from './SpecimenSourceForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { medicalRegistry } = services;
const { specimenSourceService } = medicalRegistry;

export default {
  name: 'SpecimenSourceCreate',
  components: {
    SpecimenSourceForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Create Specimen Source',
      enableBackButton: true,
    },
  }),
  methods: {
    async onSubmit(data) {
      this.isLoading = true;
      try {
        const { _id: id } = await specimenSourceService.create({ specimenSource: data });

        this.$snackbar.showOk({ text: 'Successfully created specimen source!' });

        this.$router.replace({ name: 'specimen-source.edit', params: { id } });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
